"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const address_1 = __importDefault(require("../../address"));
const carrier_class_1 = __importDefault(require("../carrier.class"));
const carrierIdentifier_1 = __importDefault(require("../carrierIdentifier"));
const errors_1 = __importStar(require("../../errors"));
class RoadCarrier extends carrier_class_1.default {
    constructor(id, name, equipmentType, email, phone, ein, address, otherEquipmentType, carrierId) {
        super(__1.eTransportMode.ROAD, id, name, email, phone, ein, address, carrierId);
        this.equipmentType = equipmentType;
        this.otherEquipmentType = otherEquipmentType;
    }
    static getCarrierId(data) {
        let carrierId = carrierIdentifier_1.default.fromObj(data === null || data === void 0 ? void 0 : data.carrierId);
        if (!carrierId && (data === null || data === void 0 ? void 0 : data.usDotNumber)) {
            carrierId = new carrierIdentifier_1.default("USDOT", data === null || data === void 0 ? void 0 : data.usDotNumber);
        }
        if (!carrierId && (data === null || data === void 0 ? void 0 : data.mcMxFfNumber)) {
            carrierId = new carrierIdentifier_1.default("MCMXFF", data === null || data === void 0 ? void 0 : data.mcMxFfNumber);
        }
        if (!carrierId && (data === null || data === void 0 ? void 0 : data.scacCode)) {
            carrierId = new carrierIdentifier_1.default("SCAC", data === null || data === void 0 ? void 0 : data.scacCode);
        }
        return carrierId;
    }
    update(carrier) {
        super.update(carrier);
        const newCarrierId = RoadCarrier.getCarrierId(carrier);
        if (newCarrierId) {
            this.carrierId = newCarrierId;
        }
    }
    static fromObj(data) {
        const carrierId = RoadCarrier.getCarrierId(data);
        return new RoadCarrier(data.id, data.name, data.equipmentType, data.email, data.phone, data.ein, data.address ? address_1.default.fromObj(data.address) : undefined, data.otherEquipmentType, carrierId);
    }
    static empty() {
        return new RoadCarrier("", "", 0);
    }
    static carrierIdTypeItems() {
        return [
            {
                text: "USDOT",
                value: "USDOT"
            },
            {
                text: "MCMXFF",
                value: "MCMXFF"
            },
            {
                text: "SCAC",
                value: "SCAC"
            }
        ];
    }
    static getCarrierIdTypeLabel(carrierIdType) {
        switch (carrierIdType) {
            case "USDOT":
                return "US DOT number";
            case "MCMXFF":
                return "MC/MX/FF number";
            case "SCAC":
                return "SCAC number";
            default:
                return "US DOT number";
        }
    }
    validate(path, isPrimary = true) {
        const errors = [];
        errors.push(...super.validate(path, false));
        if (isPrimary) {
            if (!this.equipmentType) {
                errors.push(new errors_1.default(errors_1.eErrorCode.EQUIPMENT_TYPE_NOT_SET, `${path}.equipmentType`));
            }
            if (this.equipmentType === 1 && !this.otherEquipmentType) {
                errors.push(new errors_1.default(errors_1.eErrorCode.OTHER_EQUIPMENT_TYPE_NOT_SET, `${path}.otherEquipmentType`));
            }
        }
        return errors;
    }
}
exports.default = RoadCarrier;
//# sourceMappingURL=roadCarrier.class.js.map